import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { AutoForm } from '../../../playground/common/auto-form';
import { FAMILY_SAVINGS_V2_FIELDS } from './fields';
import { FamilySavingsV2ResultView } from './result-view';
import {
  FamilySavingsV2FormValues,
  familySavingsV2Defaults,
  familySavingsV2Schema,
} from './schema';
import { buildFamilySavingsV2Payload, simulateFamilySavingsV2 } from './service';

export function FamilySavingsV2Page() {
  const [lastRequest, setLastRequest] = useState<unknown>(null);

  const mutation = useMutation({
    mutationFn: (values: FamilySavingsV2FormValues) => simulateFamilySavingsV2(values),
  });

  const hasResult = mutation.isSuccess || mutation.isError;

  return (
    <>
      <div className="card">
        <div className="card-body">
          <AutoForm
            fields={FAMILY_SAVINGS_V2_FIELDS}
            schema={familySavingsV2Schema}
            defaults={familySavingsV2Defaults}
            isLoading={mutation.isLoading}
            onSubmit={(values) => {
              setLastRequest(buildFamilySavingsV2Payload(values));
              mutation.mutate(values);
            }}
          />
        </div>
      </div>

      {hasResult && (
        <FamilySavingsV2ResultView
          request={lastRequest}
          response={mutation.data}
          error={mutation.isError ? mutation.error : undefined}
        />
      )}
    </>
  );
}
